<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="submit">
      <dt-input
        type="text"
        name="username"
        label="Username"
        v-model="username"
        validate="required"
      />
      <dt-input
        type="password"
        name="password"
        label="Password"
        v-model="password"
        validate="required"
      />
      <button
        type="submit"
        class="btn btn-primary btn-block"
        :disabled="$loading.isLoading('getToken')"
      >
        Log In
        <i
          v-if="$loading.isLoading('getToken')"
          class="fa fa-spinner fa-spin"
          aria-hidden="true"
        ></i>
      </button>
      <dt-message
        v-model="message"
        class="alert alert-warning mt-2"
      />
    </form>
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DtInput from '@/components/utilities/form/dt-input'
import DtMessage from '@/components/utilities/form/dt-message'
export default {
  name: 'form-login',
  components: {
    DtInput,
    DtMessage
  },
  data() {
    return {
      message: '',
      username: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['passthrough'])
  },
  methods: {
    ...mapActions('auth', ['getToken']),
    async submit() {
      try {
        this.message = ''
        this.$refs.form.validate().then(async success => {
          if (success) {
            await this.getToken([this.username, this.password])
            let page = this.passthrough || '/'
            this.$router.push(page)
          }
        })
        // }
      } catch (e) {
        // TODO: This error message should come from the API
        // TODO: Use of toast
        console.error(e)
        this.message = 'Error: Unable to login'
        if (e.response.status === 401 || e.response.status === 403) {
          this.message = 'Incorrect username or password'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/form-login.vue